import { render, staticRenderFns } from "./MiniProgress.vue?vue&type=template&id=6a460596&scoped=true"
import script from "./MiniProgress.vue?vue&type=script&lang=js"
export * from "./MiniProgress.vue?vue&type=script&lang=js"
import style0 from "./MiniProgress.vue?vue&type=style&index=0&id=6a460596&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a460596",
  null
  
)

export default component.exports